import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const ArrowDown: BleskIcon = forwardRef(function ArrowDown(props, ref) {
  return (
    <BaseIcon {...props} ref={ref}>
      <path
        d="M12 19V5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.001 13.999L12 19L6.99902 13.999"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
});
